import React, { useState, useEffect } from 'react';
import './TrainAndTravel.css';
import { db } from '../../firebase';
import { collection, query, orderBy, getDocs } from 'firebase/firestore';
import { YouTubeEmbed } from '../YouTubeSection';

function TrainAndTravel() {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);

    // Lightbox State (for clicking and zooming images)
    const [selectedMedia, setSelectedMedia] = useState(null);

    useEffect(() => {
        const fetchPosts = async () => {
            try {
                const q = query(collection(db, "traintravel"), orderBy("createdAt", "desc"));
                const querySnapshot = await getDocs(q);
                setPosts(querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
            } catch (error) {
                console.error("Error fetching posts:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchPosts();
    }, []);

    const openLightbox = (mediaItem) => {
        if (mediaItem.type === 'image') {
            setSelectedMedia(mediaItem);
        }
    };

    const closeLightbox = () => {
        setSelectedMedia(null);
    };

    if (loading) return <div className="tt-loading">Se încarcă experiențele...</div>;

    return (
        <div className="tt-container">
            <header className="tt-header">
                <h1>Train & Travel</h1>
                <p>Jurnal de performanță, competiții și lifestyle.</p>
                <div className="tt-separator"></div>
            </header>

            <div className="tt-feed">
                {posts.map(post => (
                    <article key={post.id} className="tt-post">
                        {/* Header of the post */}
                        <div className="tt-post-header">
                            <div className="tt-avatar-placeholder">HC</div>
                            <div className="tt-meta">
                                <h3>{post.title}</h3>
                                <span className="tt-date">
                                    {post.createdAt?.toDate ? post.createdAt.toDate().toLocaleDateString('ro-RO', { day: 'numeric', month: 'long', year: 'numeric' }) : ''}
                                </span>
                            </div>
                        </div>

                        {/* Description - THIS IS THE FIX */}
                        <p
                            className="tt-description"
                            style={{ whiteSpace: 'pre-wrap' }}
                        >
                            {post.description}
                        </p>

                        {/* Media Gallery Grid */}
                        <div className={`tt-gallery gallery-count-${post.media ? post.media.length : (post.mediaUrl ? 1 : 0)}`}>
                            {/* BACKWARD COMPATIBILITY: Handles old single posts */}
                            {post.mediaUrl && !post.media && (
                                <div className="tt-media-item single">
                                    {post.type === 'video' ? (
                                        <video controls src={post.mediaUrl} className="tt-img" />
                                    ) : (
                                        <img src={post.mediaUrl} alt={post.title} className="tt-img clickable" onClick={() => openLightbox({url: post.mediaUrl, type: 'image'})} />
                                    )}
                                </div>
                            )}

                            {/* NEW MULTI-MEDIA POSTS */}
                            {post.media && post.media.map((item, index) => (
                                <div key={index} className="tt-media-item">
                                    {item.type === 'video' ? (
                                        <video controls src={item.url} className="tt-img" />
                                    ) : (
                                        <img
                                            src={item.url}
                                            alt="travel"
                                            className="tt-img clickable"
                                            onClick={() => openLightbox(item)}
                                        />
                                    )}
                                </div>
                            ))}
                        </div>

                        {/* CLIPURI YOUTUBE ALE POSTĂRII */}
                        {post.youtube && post.youtube.length > 0 && (
                            <div className="tt-youtube">
                                {post.youtube.map((link, i) => (
                                    <YouTubeEmbed key={i} url={link} title={post.title} />
                                ))}
                            </div>
                        )}
                    </article>
                ))}
            </div>

            {/* LIGHTBOX OVERLAY (FULL SCREEN ZOOM) */}
            {selectedMedia && (
                <div className="lightbox-overlay" onClick={closeLightbox}>
                    <button className="close-btn">&times;</button>
                    <img src={selectedMedia.url} alt="Fullscreen" className="lightbox-img" />
                </div>
            )}

            {posts.length === 0 && (
                <div className="no-posts">
                    <p>Momentan nu există postări.</p>
                </div>
            )}
        </div>
    );
}

export default TrainAndTravel;